/**
 * Layout dimension tokens for fixed-size elements
 */
export const layout = {
  /** Side navigation width */
  sidebarNav: "180px",

  /** Default modal width (desktop) */
  modalStandard: 700,

  /** Mobile modal width */
  modalFullscreen: "100%",

  /** Minimum clickable area for accessibility (buttons, dots) */
  touchTarget: 32,

  /** Max-width for centered readable text content */
  contentReadable: 500,

  /** Minimum modal content height */
  modalContentMin: 450,
} as const;

export type LayoutToken = keyof typeof layout;
